import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
import Main from '@/zxx/components/main'
import ErrorPage from '@/pub/components/errorpage'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import kanban from '@/zxx/components/competition/kanban'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '*',
      redirect: '/main'
    },
    {
      path: '',
      redirect: '/main'
    },
    {
      path: '/main',
      name: 'main',
      component: Main,
      meta: {
        isDefault: true
      },
      children: [
      ]
    },
    {
      path: '/error',
      name: "error",
      component: ErrorPage,
    },
    {
      path: '/kanban',
      name: 'kanban',
      component: kanban,
    },
  ]
})

//去掉路由重复的报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  try { return originalPush.call(this, location).catch(err => err) } catch (error) { }
}

//路由守卫
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  if (to.name === "kanban") {
    next();
  }
  else if (to.name === "error") {
    //错误页面进来，回到main
    if (!to.params.is_error) {
      next('main');
      return;
    }
  } else if (from.path == '/') {
    //刷新进来，验证登录
    var res = null;
    try {
      res = await Vue.prototype.z_get("access/api/home/checklogin");
    } catch (err) {
      if (err.error && err.error.request.status === 0) {
        //没网络，去error
        console.log("网络错误", err)
        next({ name: 'error', params: { is_error: true } })
      } else if (err.code === 1 || err.code === 401) {
        //登录失效，去login
        console.log("验证登录失效", err)
        window.location.href = `${window.location.origin}/login.html?t=${new Date().getTime().toString(16)}`;
      } else {
        console.log("未知原因", err)
      }
      return
    }
    //验证成功
    window.localStorage.setItem("AccountInfo", JSON.stringify(res.data));
    store.commit('setAccountInfo', res.data);
  } else {
    //不是刷新，直接跳转，看权限
    var hasAu = store.state.navTabs.menuTreeListFlatten.filter(item => item.menu_link == to.name);
    if ((to.meta.isDev && Vue.prototype.$isDeveloper() == false)
      || (hasAu.length == 0 && !to.meta.isDefault)) {
      NProgress.done();
      vm.$message({
        message: "找不到对应权限!",
        type: "warning",
        duration: 1000
      });
      return;
    }
  }
  next();
  store.commit('navTabs/setActiveTabName', to.name);
  store.commit('navTabs/addBreadCrumb', to.name);
  store.commit('navTabs/addTabList', to.name);
  store.commit('navTabs/setGlobalProjectVisible', false);
})
router.afterEach(route => {
  NProgress.done();
});

export default router;
